/* APC Cart Guard v4 - exact pair integrity for the native Palo Alto cart.
 *
 * Every current customization add path stamps both the collar and hidden service
 * line with the same _apc_pair_id. Removal uses that identity only. Pair-less
 * legacy lines are never guessed by adjacency: preserving a line is safer than
 * silently deleting a different customer's customization.
 *
 * refreshCart() always dispatches theme:cart:refresh, on every page. A prior
 * revision reloaded the whole document on the standalone /cart page instead;
 * that traded a real speed regression for no verified benefit, so it's gone.
 */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function isAddon(item) {
    return Boolean(
      item
      && (
        (item.properties && item.properties._cf_ === 'addonProduct')
        || item.product_type === 'Custom'
      )
    );
  }

  function pairIdOf(item) {
    return (item && item.properties && item.properties._apc_pair_id) || '';
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js ' + response.status);
        return response.json();
      });
  }

  function postUpdates(updates) {
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/update.js ' + response.status);
      return response.json();
    });
  }

  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function pairRemovalUpdates(items, clicked) {
    var updates = {};
    var pairId = pairIdOf(clicked);

    if (!pairId) {
      updates[clicked.key] = 0;
      return updates;
    }

    items.forEach(function (item) {
      if (pairIdOf(item) === pairId) updates[item.key] = 0;
    });
    return updates;
  }

  function removeClickedPair(key) {
    return fetchCart().then(function (cart) {
      var items = Array.isArray(cart.items) ? cart.items : [];
      var clicked = items.find(function (item) { return item.key === key; });
      if (!clicked) return null;
      return postUpdates(pairRemovalUpdates(items, clicked));
    });
  }

  document.addEventListener('click', function (event) {
    if (event.__apcPairRemovalHandled || !event.target || !event.target.closest) return;

    var removeEl = event.target.closest('[data-item-remove]');
    if (!removeEl || !removeEl.closest('cart-element')) return;

    var row = removeEl.closest('[data-cart-item]');
    var key = row && row.dataset.item;
    if (!key) return;

    event.__apcPairRemovalHandled = true;
    event.preventDefault();
    event.stopImmediatePropagation();

    removeClickedPair(key)
      .then(refreshCart)
      .catch(function (error) {
        console.error('APC cart-guard removal failed:', error);
        refreshCart();
      });
  }, true);

  function sweepOrphanAddons() {
    fetchCart().then(function (cart) {
      var items = Array.isArray(cart.items) ? cart.items : [];
      var collarPairIds = {};

      items.forEach(function (item) {
        var pairId = pairIdOf(item);
        if (!isAddon(item) && pairId) collarPairIds[pairId] = true;
      });

      var updates = {};
      items.forEach(function (item) {
        var pairId = pairIdOf(item);
        if (isAddon(item) && pairId && !collarPairIds[pairId]) updates[item.key] = 0;
      });

      if (!Object.keys(updates).length) return null;
      return postUpdates(updates).then(function () {
        document.dispatchEvent(new CustomEvent('apc:cart-integrity-failure', {
          detail: { operation: 'update', outcome: 'exception', reason: 'orphan_addon_swept' }
        }));
        refreshCart();
      });
    }).catch(function () {});
  }

  function maybeSweepOrphanAddons() {
    if (typeof window.__apcCartCount === 'number' && window.__apcCartCount === 0) return;
    sweepOrphanAddons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeSweepOrphanAddons);
  } else {
    maybeSweepOrphanAddons();
  }
})();
